// No em dash (U+2014) or en dash (U+2013) may reach a prospect (house rule).
// The server already strips dashes from Otto's transcript; this is the render
// time guard for every string the page shows (captions, notices, "What Otto
// heard"). Adapted from ottos-consult src/consult/visibleText.js (see
// PORTED-FROM.md), extended to en dashes, which v2's rule also bans.
//
// This file must never contain either dash character itself, so they are
// built from their code points.
const EM_DASH = String.fromCharCode(0x2014);
const EN_DASH = String.fromCharCode(0x2013);
const HORIZONTAL_BAR = String.fromCharCode(0x2015);

const ANY_DASH = new RegExp(`[${EM_DASH}${EN_DASH}${HORIZONTAL_BAR}]`);
// A dash between two numbers is a range: "5 to 10" reads the same aloud.
const DASH_BETWEEN_DIGITS = new RegExp(`(\\d)\\s*[${EM_DASH}${EN_DASH}${HORIZONTAL_BAR}]+\\s*(?=\\$?\\d)`, "g");
const DASH_RUN = new RegExp(`[^\\S\\n]*[${EM_DASH}${EN_DASH}${HORIZONTAL_BAR}]+[^\\S\\n]*`, "g");

export function hasDash(value: string): boolean {
  return ANY_DASH.test(value);
}

/** Replace every em or en dash with a comma (or "to" between numbers), then tidy. */
export function stripDashes(value: string): string {
  const text = String(value ?? "");
  if (!ANY_DASH.test(text)) return text;
  return text
    .replace(DASH_BETWEEN_DIGITS, "$1 to ")
    .replace(DASH_RUN, ", ")
    .replace(/^,\s*/, "")
    .replace(/,\s*$/, "")
    .replace(/,\s*([,.;:!?])/g, "$1")
    .replace(/ {2,}/g, " ");
}
